module.exports = __webpack_public_path__ + "static/procesDystrybucjaMobile@x1-642bffe725ab98df1e8eb24a042cb051.png";